import React from "react";
import { Container, Ship, Anchor } from "lucide-react";

const rows = [
  { title: "FCL Shipments", desc: "20 FT & 40 FT container loading based on product density and buyer packing." },
  { title: "Incoterms", desc: "FOB, CFR and CIF as per buyer requirement and destination." },
  { title: "Port Coordination", desc: "Loading and documentation typically via Mundra and Nhava Sheva." },
  { title: "Documentation", desc: "Commercial invoice, packing list, bill of lading, phytosanitary and inspection documents." },
];

const Logistics = () => (
  <div>
    <section className="bg-[#004225] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-[11px] font-eyebrow text-[#D4AF37]"><span className="gold-line mr-3" />Logistics</div>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl">From Port to Destination</h1>
        <p className="mt-3 max-w-2xl text-white/80">End-to-end export logistics coordination — containerization, port stuffing, sailing schedule alignment and full documentation.</p>
      </div>
    </section>
    <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-2 gap-4">
      {rows.map((r, i) => (
        <div key={r.title} className="bg-white border border-[#004225]/10 rounded-sm p-6 card-elevate">
          {i === 0 ? <Container className="h-5 w-5 text-[#D4AF37]" /> : i === 1 ? <Anchor className="h-5 w-5 text-[#D4AF37]" /> : <Ship className="h-5 w-5 text-[#D4AF37]" />}
          <div className="mt-3 font-display text-lg text-[#004225]">{r.title}</div>
          <p className="mt-2 text-[13px] text-[#171717]/75">{r.desc}</p>
        </div>
      ))}
    </section>
  </div>
);

export default Logistics;
